import {useState} from 'react';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Card } from "@mui/material";
import TechResultsPane from './TechResultsPane';
import TechFilterPane from './TechFilterPane';
import TechStatBanner from './TechStatBanner';
import ProviderPopover from './ProviderPopover';

const theme = createTheme({
  typography: {
    fontFamily: ["Radio Canada Big", "Arial"].join(",")
  }
});

const backgroundColor = '#ffffff';

function ApproveProviders(props) {
    const [activeResult, setActiveResult] = useState(null);
    const [ techProviders, setTechProviders ] = useState([]);
    const [ filteredTechProviders, setFilteredTechProviders ] = useState([]);
    const [ admin, setAdmin ] = useState(true);
    const [ refreshList, setRefreshList ] = useState(false);

    const selectedResult = (result) => {
      setActiveResult(result);
  }

  return (
<ThemeProvider theme={theme}>
    <Box sx={{ flexGrow: 1 }}>

        <Card sx={{backgroundColor: '#f1f1f1', width: '95%', marginLeft: 'auto', marginRight: 'auto'}}>
          <TechResultsPane {...props} {...{admin, refreshList, setRefreshList, techProviders, setTechProviders, filteredTechProviders, setFilteredTechProviders}} onSelectResult={selectedResult} />
        </Card>
    </Box>
    <ProviderPopover {...props} {...{ admin, setRefreshList, activeResult, setActiveResult, techProviders }} />
</ThemeProvider>
  );
}

export default ApproveProviders;
